import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './ProgressBar.module.scss';

// Replace these HTMLAttributes with your correct one
type ProgressBarProps = HTMLAttributes<HTMLDivElement> & {
  text: string;
  percentage: number;
  secondaryLabel?: string;
};

const clampPercentage = (percentage: number) => {
  return Math.min(Math.max(percentage, 0), 100);
};

export const ProgressBar = ({ className, text, percentage, secondaryLabel, ...rest }: ProgressBarProps) => {
  const classNames = joinClassNames(styles.progressBarTrack, className);
  return (
    <div className={classNames} {...rest}>
      <div className={styles.progressBar} style={{ width: `${clampPercentage(percentage)}%` }} />
      <div className={styles.progressBarText}>
        {text} <span className={styles.progressBarPercentage}>({clampPercentage(percentage)}%)</span>
      </div>
      {secondaryLabel && <div className={styles.progressBarSecondaryLabel}>{secondaryLabel}</div>}
    </div>
  );
};

ProgressBar.displayName = 'ProgressBar';
